module.exports = __webpack_public_path__ + "static/media/14@1024w.cf6b5f00.jpg";